import { createFileRoute } from "@tanstack/react-router";
import { PageLayout } from "../components/PageLayout";
import { LogOut } from "lucide-react";
import { Button } from "@patient-watch/ui";
import { Link } from "@tanstack/react-router";
import { useCopy } from "../i18n/locale";

export const Route = createFileRoute("/logged-out")({
    component: RouteComponent,
});

function RouteComponent() {
    const copy = useCopy();
    return (
        <PageLayout title={copy.loggedOut.title} description={copy.loggedOut.description} icon={LogOut} theme="red">
            <div className="flex flex-col justify-center items-center gap-4">
                <Button asChild variant="default">
                    <Link to="/">{copy.common.backHome}</Link>
                </Button>
            </div>
        </PageLayout>
    );
}
